export default function SpinnerService($rootScope) {
    'ngInject';

    Object.assign(this, {
        showSpinner,
        hideSpinner,
    });

    function showSpinner() {
        $rootScope.isLoading = true;
    }

    function hideSpinner() {
        $rootScope.isLoading = false;
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/common/widgets/spinner-service.js